import { useContext } from "react";

import ThemeContext from "../../../context.ts";

export default function useGetConnectCallback() {
	const { state, isFrame } = useContext(ThemeContext);

	const isInvalidToken = state.errorMessage === "token_not_found";

	const onExit = (status: string = "SUCCESS") => {
		if (isFrame) {
			if (window !== null && window.top !== null)
				window.top.postMessage(
					{ type: "iframeUrl", finished_by: isInvalidToken ? "INVALID_TOKEN" : status },
					"*"
				);
		} else if (state.redirectUri) {
			const redirectUrl = `${state.redirectUri}?entity=${state.entity?.id}&finished_by=${status}`;
			window.location.href = redirectUrl;
		}
	};

	return { onExit };
}
